import React from 'react';
import './App.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CalcPage from './CalcPage';
import MainPage from './MainPage';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={< MainPage />} />
        <Route path="/calc" element={< CalcPage />} />
      </Routes>
    </Router>
  );
}

export default App;
